import { render, staticRenderFns } from "./SiteList.vue?vue&type=template&id=56db3fdc&scoped=true"
import script from "./SiteList.vue?vue&type=script&lang=js"
export * from "./SiteList.vue?vue&type=script&lang=js"
import style0 from "./SiteList.vue?vue&type=style&index=0&id=56db3fdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56db3fdc",
  null
  
)

export default component.exports